export default __webpack_public_path__ + "static/media/account_guides.9a2f3252.png";